import styled from 'styled-components';
import Dropzone from 'react-dropzone';
export const DropArea = styled(Dropzone) `
  text-align: center;
  cursor: pointer;
  border: 2px dashed rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 1rem;
  background-color: rgba(0,0,0,0.05);
  color: rgba(0,0,0,0.7);
  &:hover {
    border: 2px dashed rgba(0,0,0,0.2);
    background-color: rgba(0,0,0,0.1);
    color: rgba(0,0,0,1);
  }
`;
//# sourceMappingURL=dropArea.js.map